import { render, staticRenderFns } from "./c_xbutton.vue?vue&type=template&id=0b3b5b54&scoped=true"
import script from "./c_xbutton.vue?vue&type=script&lang=js"
export * from "./c_xbutton.vue?vue&type=script&lang=js"
import style0 from "./c_xbutton.vue?vue&type=style&index=0&id=0b3b5b54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3b5b54",
  null
  
)

export default component.exports